import { useState, useEffect, useRef } from "react";
import api, { API_URL, showAlert, Stars, toNaira } from "../util/api";
import { Link, useSearchParams } from "react-router-dom";
import "../assets/doctor-search.css";
/* import './liststyle.css'; */
import "./doctor-explorer.css";

import PremiumLoader from "../loading";
import { tr } from "framer-motion/client";
import { FaBullseye } from "react-icons/fa";



export default function DoctorList() {

    const [loading, setLoading] = useState(false);
    const [doctors, setDoctors] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const isFetching = useRef(false); // ✅ prevents duplicate fetch

    const [searchParams] = useSearchParams();



    // GET PARAMETERS
    /*     const  [specialty , setSpecialty] = useState(searchParams.get("specialty"));
        const minFee = searchParams.get("minFee");
        const maxFee = searchParams.get("maxFee");
        const rating = searchParams.get("rating");
        const experience = searchParams.get("experience");
        const availability = searchParams.get("availability");
        const patients = searchParams.get("patients");
     */


    //search parameters  

    const [symptom, setSymptom] = useState("");
    const [specialty, setSpecialty] = useState("");
    const [specialties, setSpecialties] = useState([]);
    const [recommended, setRecommended] = useState([]);
    const [searching, setSearching] = useState(false);


    /* 🔹 NEW FILTER STATES */
    const [minFee, setMinFee] = useState("");
    const [maxFee, setMaxFee] = useState("");
    const [rating, setRating] = useState("");
    const [experience, setExperience] = useState("");
    const [availability, setAvailability] = useState("");
    const [patients, setPatients] = useState("");
    const [showFilters, setShowFilters] = useState(false);


    useEffect(() => {
        const fetchSpecialties = async () => {
            const res = await api.get(API_URL + "/specialties");
            setSpecialties(res.data);
        };
        fetchSpecialties();
    }, []);


    const handleSymptomChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSymptom(value);

        if (!value) {
            setRecommended([]);
            return;
        }

        const matched = specialties.filter(spec =>
            spec.symptoms?.some(sym =>
                sym.name.toLowerCase().includes(value)
            )
        );

        setRecommended(matched);
    };

    /* =========================
       SELECT SPECIALTY
    ========================== */
    const handleSpecialtySelect = async (value) => {
        setSpecialty(value);
        setRecommended([]);

    };



    const searchNow = async () => {

        if (searching) return;
        setLoading(true);

        setSearching(true);

        isFetching.current = false;
        setHasMore(true);
        setDoctors([]);
        setPage(1);

        

        try {
            const response = await api.get(`${API_URL}/doctors?page=1`, {
                params: {
                    specialty,
                    minFee,
                    maxFee,
                    rating,
                    experience,
                    availability,
                    patients
                }
            });

            if (response.data.status === 'success') {
                setDoctors(response.data.data);
                setHasMore(response.data.meta.has_more);
            }
        } catch (error) {
            showAlert('error', 'error', error);
        } finally {
            setSearching(false);
            setLoading(false);
        }
    };




    const fetchDoctors = async () => {



        if (isFetching.current || !hasMore) return;



        isFetching.current = true;
        setLoading(true);

        try {
            const response = await api.get(`${API_URL}/doctors?page=${page}`, {
                params: {
                    specialty,
                    minFee,
                    maxFee,
                    rating,
                    experience,
                    availability,
                    patients
                }
            });

            if (response.data.status === 'success') {
                setDoctors(prev => [...prev, ...response.data.data]);
                setHasMore(response.data.meta.has_more);
            }
        } catch (error) {
            showAlert('error', 'error', error);
            // console.error("Error fetching doctors:", error);
            setLoading(false);
            isFetching.current = false;
        } finally {
            setLoading(false);
            isFetching.current = false;
        }
    };

    /* ✅ Fetch ONLY when page changes */
    useEffect(() => {
        fetchDoctors();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    /* ✅ Infinite Scroll */
    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.body.offsetHeight - 150 &&
                hasMore &&
                !loading &&
                !isFetching.current
            ) {
                setPage(prev => prev + 1);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [hasMore, loading]);

    return (
        <>
            <section className="doctor-explorer">
                <div className="container">

                    {/* SEARCH */}
                    <div className="search-wrapper">

                        {/* search  space  */}



                        <div className="search-page">

                            <div className="search-title">
                                <h1>Find a doctor</h1>
                                <p>Search by symptom, specialty or availability</p>
                            </div>

                            {/* FLOATING BAR */}
                            <div className="search-bar">

                                <input
                                    className="search-input"
                                    placeholder="Headache, chest pain, dentist..."
                                    value={symptom}
                                    onChange={handleSymptomChange}
                                />

                                <select
                                    className="search-select"
                                    value={specialty}
                                    onChange={(e) => setSpecialty(e.target.value)}
                                >
                                    <option value="">Specialty</option>
                                    {specialties.map(spec => (
                                        <option key={spec.id} value={spec.name}>{spec.name}</option>
                                    ))}
                                </select>

                                <button
                                    className="icon-btn"
                                    onClick={() => setShowFilters(prev => !prev)}
                                >
                                    Filters
                                </button>

                                <button
                                    className="go-btn"
                                    onClick={searchNow}
                                    disabled={searching}
                                >
                                    {searching ? "Go.." : "Go"}
                                </button>

                            </div>

                            {/* RECOMMENDATIONS */}
                            {recommended.length > 0 && (
                                <div className="recommend">
                                    {recommended.map(spec => (
                                        <div key={spec.id} onClick={() => handleSpecialtySelect(spec.name)}>
                                            {spec.name}
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* FILTERS */}
                            {showFilters && (
                                <div className="filters">
                                    <input type="number" placeholder="Min fee" value={minFee} onChange={e => setMinFee(e.target.value)} />
                                    <input type="number" placeholder="Max fee" value={maxFee} onChange={e => setMaxFee(e.target.value)} />

                                    <select style={{ marginBottom: "0px" }} value={rating} onChange={e => setRating(e.target.value)}>
                                        <option value="">Rating</option>
                                        <option value="5">⭐⭐⭐⭐⭐</option>
                                        <option value="4">⭐⭐⭐⭐+</option>
                                        <option value="3">⭐⭐⭐+</option>
                                        <option value="2">⭐⭐+</option>
                                    </select>

                                    <input type="number" placeholder="Experience (yrs)" value={experience} onChange={e => setExperience(e.target.value)} />

                                    <select style={{ marginBottom: "0px" }} value={availability} onChange={e => setAvailability(e.target.value)}>
                                        <option value="">Availability</option>
                                        <option value="weekday">Mon–Fri</option>
                                        <option value="weekend">Weekend</option>
                                        <option value="all">All days</option>
                                    </select>
                                </div>
                            )}



                        </div>




                        {/* end search space   */}





                       
                    </div>

                    {/* FIRST LOAD */}
                    {loading && doctors.length === 0 && (
                        <div className="loader-center">
                            <PremiumLoader />
                        </div>
                    )}

                    {/* EMPTY STATE */}
                    {!loading && doctors.length === 0 && (
                        <div className="empty-state">
                            <h3>No Doctors Available</h3>
                            <p>Try adjusting your filters or check back later.</p>
                        </div>
                    )}

                    {/* DOCTOR GRID */}
                    <div className="doctor-grid">
                        {doctors.map((doctor) => (
                            <div className="doctor-glass-card" key={doctor.id}>

                                {/* IMAGE */}
                                <div className="doctor-avatar">
                                    <div className="avatar-bg"></div>

                                    <img
                                        src={doctor.profilePicture}
                                        alt={doctor.name}
                                        loading="lazy"
                                    />

                                    <span
                                        className={`status-dot ${doctor.total_availability > 0 ? "active" : "inactive"
                                            }`}
                                    >
                                        {doctor.total_availability > 0 ? "Available" : "Offline"}
                                    </span>
                                </div>


                                {/* CONTENT */}
                                <div className="doctor-body">
                                    <h4>{doctor.name}</h4>

                                    <p className="speciality">
                                        {doctor.speciality ? JSON.parse(doctor.speciality)[0] : ""}
                                    </p>

                                    <p className="experience">
                                        {doctor.experience} years experience
                                    </p>

                                    <div className="rating-row">
                                        <Stars value={doctor.average_rating} size={18} />
                                        <span>{doctor.average_rating}</span>
                                    </div>

                                   {/*  <div className="fee">
                                        {toNaira(doctor.consultationFee)}
                                    </div> */}

                                    {/* ACTIONS */}
                                    <div className="action-row">
                                        <Link
                                            to={`/doctor-profile/${doctor.id}`}
                                            className="btn-outline"
                                        >
                                            Profile
                                        </Link>

                                        {doctor.total_availability > 0 && (
                                            <Link
                                                to={`/doctor-profile/${doctor.id}`}
                                                className="btn-primary"
                                            >
                                                Book
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* LOAD MORE */}
                    {loading && doctors.length > 0 && (
                        <div className="loader-center">
                            <PremiumLoader />
                        </div>
                    )}

                </div>
            </section>

        </>
    );
}
